import React from "react";
import { makeStyles } from "@material-ui/styles";
import Map from "./Map";

const useStyles = makeStyles({
    root: {
        padding: "0 !important",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: 800,
        width: "100%",
    },
    content: {
        display: "flex",
        flexGrow: 1,
        padding: 0
    }
});

export default function MapCard({ pin, isManuallyAdded, details, setDetails }) {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div className={classes.content}>
                <Map pin={pin} isManuallyAdded={isManuallyAdded} details={details} setDetails={setDetails} />
            </div>
        </div>
    )
}